import React, { useState } from "react";
import { GoogleLogin } from "@react-oauth/google"; // Import Google Login component
import "./LoginModal.css";

const LoginModal = ({ onLogin }) => {

    // Google Login success callback
    const handleGoogleSuccess = (credentialResponse) => {
        try {
            const token = credentialResponse.credential; // Token from Google
            // Decode Google JWT to get email (payload is base64url, not encrypted)
            const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
            if (payload.email) localStorage.setItem('userEmail', payload.email);

            // Here you might send the `token` to your backend for verification and login
            const wsUrl = process.env.REACT_APP_GAMES_CLOUD_URL; // Fetch API path, e.g., "/room1/api/config"

            if (!wsUrl) {
                console.error("REACT_APP_GAMES_CLOUD_URL is not defined. - set to default");
            }

            const updatedUrl = wsUrl.replace(/^ws/, "http").replace(/ws$/, "auth/token");

            const defaultHeaders = {
                Authorization: `Bearer ${credentialResponse.credential}`,
                "Content-Type": "application/json", // Default Content-Type
            };

            const finalOptions = {
                headers: {
                    ...defaultHeaders,
                },
            };

            // Send the Google token to the backend
            fetch(updatedUrl, finalOptions)
                .then((res) => {
                    if (!res.ok) {
                        throw new Error("Login failed");
                    }
                    console.log("Login successful! Cookie set by backend.");
                    return res.json(); // IMPORTANT: Process response body to JSON!
                })
                .then((data) => {
                    // Access the token from the response
                    if (!data.token) {
                        throw new Error("Token not provided in the response");
                    }
                    // Save the token to localStorage
                    try {
                        localStorage.setItem("accessToken", data.token);
                        console.log(
                            "Token saved to localStorage successfully:",
                            localStorage.getItem("accessToken")
                        );
                        onLogin(); // Notify the parent that the user has logged in
                    } catch (error) {
                        console.error("Error saving to localStorage:", error);
                    }
                })
                .catch((error) => {
                    console.error("Error during login:", error);
                    alert("Login failed. Please try again.");
                });
        } catch (error) {
            console.error("Error loggin in: ", error);
        }
    };

    // Google Login failure handler
    const handleGoogleFailure = (error) => {
        console.error("Google Login Failed: ", error);
        alert("Failed to login with Google. Please try again.");
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <img className="modal-mark" src="/riddlehouse-logo.svg" alt="Riddlehouse" />
                <h2>GM <span>HUD</span></h2>
                <p className="modal-subtitle">Sign in to continue</p>
                <hr className="modal-divider" />
                <div className="google-login">
                    <span className="google-login-label">Continue with Google</span>
                    <GoogleLogin
                        onSuccess={handleGoogleSuccess}
                        onError={handleGoogleFailure}
                    />
                </div>
            </div>
        </div>
    );
};

export default LoginModal;